import { validateCode128, validateEan13 } from './barcode';
import { lateralSlack, margins, occupiedWidth } from './geometry';
import { findMacros, MACRO_KEYS, renderSample, unknownMacros } from './macros';
import { getPrinter } from './printers';

export function validateRoll(r, printer) {
  const out = [];
  const campos = [
    ['Largura da bobina', r.rollWidth],
    ['Largura da etiqueta', r.labelWidth],
    ['Altura da etiqueta', r.labelHeight],
    ['Espaçamento horizontal', r.hGap],
    ['Espaçamento vertical', r.vGap],
    ['Margem esquerda', r.autoCenter ? 0 : r.manualLeftMargin],
  ];
  for (const [nome, valor] of campos) {
    if (!(valor >= 0) || !Number.isFinite(valor)) out.push({ level: 'erro', msg: `${nome} não pode ser negativa` });
  }
  if (r.labelWidth <= 0 || r.labelHeight <= 0 || r.rollWidth <= 0) {
    out.push({ level: 'erro', msg: 'Medidas da etiqueta e da bobina devem ser maiores que zero' });
  }
  if (![1, 2, 3].includes(r.columns)) out.push({ level: 'erro', msg: 'Colunas devem ser 1, 2 ou 3' });
  if (occupiedWidth(r) > r.rollWidth) {
    out.push({ level: 'erro', msg: `As colunas ocupam ${occupiedWidth(r)} mm, acima da bobina (${r.rollWidth} mm)` });
  } else if (!r.autoCenter && margins(r).right < 0) {
    out.push({ level: 'erro', msg: `A margem esquerda passa da sobra lateral (${lateralSlack(r)} mm)` });
  }
  if (printer && r.rollWidth > printer.maxWidthMm) {
    out.push({ level: 'aviso', msg: `A bobina (${r.rollWidth} mm) passa da largura da ${printer.model} (${printer.maxWidthMm} mm)` });
  }
  return out;
}

export function validateModel(model, sample, known = MACRO_KEYS) {
  const printer = getPrinter(model.printerId);
  const out = validateRoll(model.roll, printer);
  const tamanho = String(model.erp?.tamanhoDescricao || '').trim();
  if (tamanho && !/^\d+$/.test(tamanho)) {
    out.push({ level: 'erro', msg: 'Tamanho da descrição precisa ser um número inteiro de caracteres' });
  }
  for (const el of model.elements) {
    const r = model.roll;
    if (el.x < 0 || el.y < 0 || el.x + el.w > r.labelWidth + 0.01 || el.y + el.h > r.labelHeight + 0.01) {
      out.push({ level: 'aviso', msg: `"${el.name}" ultrapassa a etiqueta`, elementId: el.id });
    }
    if (el.type === 'text' || el.type === 'barcode') {
      for (const k of unknownMacros(el.content, known)) {
        out.push({ level: 'erro', msg: `Macro desconhecida {${k}} em "${el.name}"`, elementId: el.id });
      }
      for (const k of findMacros(el.content)) {
        if (sample[k] === '') out.push({ level: 'aviso', msg: `{${k}} sem exemplo na prévia`, elementId: el.id });
      }
      if (printer.erpLanguage === 'ZPL' && /[\^~]/.test(el.content)) {
        out.push({ level: 'erro', msg: `"${el.name}" contém ^ ou ~, reservados no ZPL`, elementId: el.id });
      }
    }
    if (el.type === 'barcode') {
      if (!printer.barcodes.includes(el.symbology)) {
        out.push({ level: 'erro', msg: `${el.symbology} não é suportado por esta impressora`, elementId: el.id });
      }
      const valor = renderSample(el.content, sample);
      const erro = el.symbology === 'EAN13' ? validateEan13(valor) : validateCode128(valor);
      if (erro) out.push({ level: 'aviso', msg: `Prévia de "${el.name}": ${erro}`, elementId: el.id });
      if (el.h < 5) out.push({ level: 'aviso', msg: `O código "${el.name}" tem menos de 5 mm de altura`, elementId: el.id });
    }
  }
  return out;
}
